"use client";

import { getAccessToken, getRefreshToken, subscribeToAuthStateChange } from "@/utils/token";
import { useSyncExternalStore } from "react";

const getIsAuthenticated = () => Boolean(getAccessToken() || getRefreshToken());
const getServerSnapshot = () => false;

const useAuth = () => {
  const isAuthenticated = useSyncExternalStore(
    onStoreChange => {
      if (typeof window === "undefined") {
        return () => undefined;
      }

      const unsubscribe = subscribeToAuthStateChange(onStoreChange);

      window.addEventListener("focus", onStoreChange);

      return () => {
        unsubscribe();
        window.removeEventListener("focus", onStoreChange);
      };
    },
    getIsAuthenticated,
    getServerSnapshot,
  );

  return { isAuthenticated };
};

export default useAuth;
